import type { FC } from 'react'

type SpinnerVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark'

type SpinnerSize = 'sm' | 'md'

type SpinnerProps = {
  size?: SpinnerSize
  className?: string
  variant?: SpinnerVariant
  animation?: string
  role?: string
}

const variantClasses: Record<SpinnerVariant, string> = {
  primary: '~text-navy',
  secondary: '~text-charcoal',
  success: '~text-grass',
  danger: '~text-cherry',
  warning: '~text-sunrise',
  info: '~text-sky',
  light: '~text-grey',
  dark: '~text-black',
}

const Spinner: FC<SpinnerProps> = ({
  size = 'md',
  className = '',
  variant,
  role = 'status',
}) => (
  <div
    role={role}
    className={`~inline-block ~animate-[spin_0.75s_linear_infinite] ~rounded-full ~border-current ~border-r-transparent ~align-text-bottom ${
      size === 'sm' ? '~h-4 ~w-4 ~border-[0.2em]' : '~h-8 ~w-8 ~border-4'
    } ${variant ? variantClasses[variant] : ''} ${className}`}
  >
    <span className="~sr-only">Loading...</span>
  </div>
)

export default Spinner
